module.exports = __webpack_public_path__ + "static/media/room1_3.396fce83.JPG";